import { constantRoutes, asyncRoutes } from '@/router'
const Layout = () => import('@/views/Layout/Layout.vue')
/**
 * 递归过滤异步路由表，返回路由下第一个子路由地址
 * @param route
 */
function filterRedirect(route) {
  let redirect = route.path

  if (route.children && route.children.length > 0) {
    let temp = ''
    if (route.showChildren != 'false') {
      for (let i of route.children) {
        if (!i.meta.sub && !i.children) {
          temp = i
          break
        }
      }
    }

    if (temp) {
      redirect = redirect + '/' + temp.path
    } else {
      if (route.showChildren != 'false') {
        for (let i of route.children) {
          if (!i.meta.sub && i.children && i.children.length > 0) {
            temp = i
            break
          }
        }
      }
      if (temp) {
        redirect = redirect + '/' + filterRedirect(temp)
      } else {
        if (route.showChildren != 'false') {
          for (let i of route.children) {
            if (!i.meta.sub) {
              temp = i
              break
            }
          }
          redirect = redirect + '/' + temp.path
        }
      }
    }
  }

  return redirect
}
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */

export async function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(async route => {
    const tmp = { ...route }

    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = await filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    defaultRoutes: [],
    topbarRouters: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes)
    },
    SET_TOPBAR_ROUTES: (state, routes) => {
      state.topbarRouters = routes
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(async resolve => {
        let { permissions, products } = data
        let accessedRoutes
        accessedRoutes = asyncRoutes.filter(route => {
          return !route.alwaysShow || products.includes(route.name)
        })
        const sdata = JSON.parse(JSON.stringify(accessedRoutes))
        const sidebarRoutes = await filterAsyncRoutes(sdata, permissions)
        const rewriteRoutes = await filterAsyncRoutes(accessedRoutes, permissions)
        if (!window.__POWERED_BY_QIANKUN__) {
          rewriteRoutes.forEach(item => {
            item.redirect = filterRedirect(item)
          })
          rewriteRoutes.unshift({ path: '/', component: Layout, hidden: true, redirect: `${accessedRoutes[0].path}` })
          rewriteRoutes.push({ path: '*', redirect: '/', hidden: true })
        }

        commit('SET_ROUTES', rewriteRoutes)
        commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
        commit('SET_DEFAULT_ROUTES', sidebarRoutes)
        commit('SET_TOPBAR_ROUTES', sidebarRoutes)
        resolve(rewriteRoutes)
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js